import queryString from 'query-string';
import moment from 'moment';
import { ACTIONS, COOKIES, APPINDICATORS } from '../constants';
// import { oesOfferings as MockOesOfferings } from '../utils/mockData';
import { getParsedCookie, removeCookie } from '../utils/cookieHelpers';
import { addAddons } from './addOns';
import packageConfig from '../utils/packageConfig.json';
import {
  mapEmailApiPlan,
  mapMarketingCampaignsPlan,
  mapEaseAddon,
  mapIpAddon,
} from '../adapters/offeringsAdapter';
import createRequest from '../utils/requestService';

export const setPackage = activePackage => ({ type: ACTIONS.SET_PACKAGE, activePackage });

function getOfferingById(offeringId) {
  return fetch(createRequest(`/v3/public/offerings/${offeringId}`, { method: 'GET' }))
    .then((resp) => {
      if (resp.ok) {
        return resp.json();
      }
      throw new Error(`Failed to load OES offering ${offeringId}`);
    });
}

function getOfferings() {
  return fetch(createRequest('/v3/public/offerings', { method: 'GET' }))
    .then((resp) => {
      if (resp.ok) {
        return resp.json().then(json => json.offerings);
      }
      throw new Error('Failed to load OES offerings');
    });
}

export function isOfferingActive(offering) {
  if (!offering) {
    return false;
  }
  const now = moment().utc();
  const startDate = moment(offering.start_date).utc();
  return startDate <= now;
}

export const getPackages = () => (dispatch) => {
  // Example AWS sign up query string:
  // ?cuuid=cde7778b-01b0-45f0-9495-b1208dee90a7&aws=pro
  const parsedQS = queryString.parse(window.location.search);
  if (parsedQS.aws) {
    removeCookie(COOKIES.SELECTED_PACKAGES);
    const { aws, cuuid } = parsedQS;
    const awsPackage = packageConfig.awsPackages[aws];
    if (!awsPackage) {
      dispatch({ type: ACTIONS.GET_PACKAGES_FAILURE });
      return Promise.resolve();
    }
    awsPackage.cuuid = cuuid;
    dispatch(setPackage([awsPackage]));
    dispatch({ type: ACTIONS.GET_PACKAGES_SUCCESS });
    return Promise.resolve();
  }

  const signUpVals = getParsedCookie(COOKIES.SELECTED_PACKAGES);
  if (!signUpVals || !signUpVals.packages) {
    dispatch({ type: ACTIONS.GET_PACKAGES_FAILURE });
    return Promise.resolve();
  }

  dispatch({ type: APPINDICATORS.PAGE_LOADING });

  const eiPlanId = signUpVals.packages.e;
  const mcPlanId = signUpVals.packages.mc;

  const eiOfferingPromise = eiPlanId ? getOfferingById(eiPlanId) : Promise.resolve();
  const mcOfferingPromise = mcPlanId ? getOfferingById(mcPlanId) : Promise.resolve();
  const offeringsPromise = getOfferings();

  return Promise.all([
    eiOfferingPromise,
    mcOfferingPromise,
    offeringsPromise,
  ])
    .then(([
      eiOffering,
      mcOffering,
      offerings,
    ]) => {
      const activePackage = [];
      if (isOfferingActive(eiOffering)) {
        activePackage.push(mapEmailApiPlan(eiOffering));
      }
      if (isOfferingActive(mcOffering)) {
        activePackage.push(mapMarketingCampaignsPlan(mcOffering));
      }
      dispatch(setPackage(activePackage));

      const addOns = {
        ...mapEaseAddon(signUpVals, eiOffering, offerings),
        ...mapIpAddon(signUpVals, offerings),
      };
      dispatch(addAddons(addOns));

      dispatch({ type: ACTIONS.GET_PACKAGES_SUCCESS });
    })
    .catch(() => {
      dispatch({ type: ACTIONS.GET_PACKAGES_FAILURE });
    })
    .finally(() => {
      dispatch({ type: APPINDICATORS.PAGE_LOADING_FINISHED });
    });
};
